/* eslint-disable class-methods-use-this */
import { requests } from '..';
import { EventType } from '../../domain/webhook/EventType';
import { Webhook } from '../../domain/webhook/Webhook';
import { WebhookDTO } from '../../domain/webhook/WebhookDTO';
import { WebhookMapper } from '../../mappers/webhook/WebhookMapper';
import { SessionRepository } from '../session/SessionRepository';
import { WebhookRepository } from './WebhookRepository';

export class WebhookRepositoryApi implements WebhookRepository {
  constructor(private sessionRepository: SessionRepository) {}
  async retrieve(projectId: string): Promise<Webhook[]> {
    const project = `?project_id=${projectId}`;
    const responseV2 = await requests.get({
      uri: `/v2/webhooks${project}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
    return responseV2.data.map((wh: WebhookDTO) => WebhookMapper.toDomain({ ...wh, api_version: 2 }));
  }

  async create(webhook: Webhook, projectId: string): Promise<Webhook> {
    const project = `?project_id=${projectId}`;
    const response = await requests.post({
      uri: `/v2/webhook${project}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
      data: {
        url: webhook.url,
        enabled: webhook.enabled,
        enabled_events: webhook.enabled_events,
      },
    });
    return WebhookMapper.toDomain(response.data);
  }
  async save(webhook: Webhook): Promise<Webhook> {
    const response = await requests.put({
      uri: `/v2/webhook/${webhook.id}`,
      headers: this.sessionRepository.getAuthenticationHeader(),
      data: {
        url: webhook.url,
        enabled: webhook.enabled,
        enabled_events: webhook.enabled_events,
      },
    });
    return WebhookMapper.toDomain(response.data);
  }
  async delete(webhook: Webhook): Promise<void> {
    if (webhook.api_version === 2) {
      await requests.delete({
        uri: `/v2/webhook/${webhook.id}`,
        headers: this.sessionRepository.getAuthenticationHeader(),
      });
    }
  }
  async test(webhook: Webhook, event: EventType): Promise<void> {
    await requests.post({
      uri: `/v2/webhook/${webhook.id}/test`,
      data: { event_type: event },
      headers: this.sessionRepository.getAuthenticationHeader(),
    });
  }
}
